export default function (component, events, ...args) {
  const self = component;
  events.split(' ').forEach((event) => {
    self.$emit(event, ...args);
  });
}



// WEBPACK FOOTER //
// ./node_modules/framework7-vue/runtime-helpers/vue-component-dispatch-event.js